import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { NetworkService } from '../services/network.service';
import { MsgInfoService } from '../services/msg-info.service';

@Injectable()
export class OfflineInterceptor implements HttpInterceptor {

  private networkService!: NetworkService;
  private msgInfoService!: MsgInfoService;

  constructor(private injector: Injector) {
    // Injection lazy pour casser la boucle circulaire
    setTimeout(() => {
      this.networkService = this.injector.get(NetworkService);
      this.msgInfoService = this.injector.get(MsgInfoService);
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!this.networkService || !this.msgInfoService) {
      return next.handle(req); // Si pas encore initialisé, passe normalement
    }

    const callMatch = req.url.match(/\/api\/Call\/(begin|ls|end)\/(.+)$/);    
    // Routes hors begin/ls/end
    if (!callMatch && !this.networkService.isOnline()  ) {
            
      this.msgInfoService.updateInfo({
        msg: '⛔ Hors ligne : cette action nécessite une connexion internet.',
        duration: 4000
      });
      return of();
    }
    
    // Routes begin/ls/end hors ligne → stockage
    if (callMatch && !this.networkService.isOnline()) {
      const stored = JSON.parse(localStorage.getItem('offline-calls') || '[]');

      stored.push({
        type: callMatch[1],
        callId: callMatch[2],
        url: req.url,
        method: req.method,
        body: req.body,
        headers: req.headers.keys().reduce((acc, key) => ({
          ...acc,
          [key]: req.headers.get(key)
        }), {}),
        timestamp: Date.now()
      });

      localStorage.setItem('offline-calls', JSON.stringify(stored));

      this.msgInfoService.updateInfo({
        msg: '⛔ Hors Ligne → Appel enregistré',
        duration: 3000
      });

      return of();
    }

    // En ligne → passe la requête normalement
    return next.handle(req);
  }
}
